<div class="annonimus_main">
  <div class="container-fluid bg-white header form-group">
    <img src="assets/images/logo-header.jpg" alt="" />
  </div>
  <div class="container-fluid inner">
    <router-outlet></router-outlet>
  </div>
  <div class="container-fluid footer mt-3">
    <h6 class="mt-3">{{'Common.PoweredBy' | translate}}</h6>
    <img class="footer_logo" src="assets/images/footer-logo.png" alt="" />
  </div>
</div>



